module.exports = __webpack_public_path__ + "static/media/img_Benchmarking302.599cf38e.png";